import { CONFIG_INSTANCES } from "./axiosInstances";

export const getAppVersionConfig = async () => {
  try {
    const response = await CONFIG_INSTANCES.get("config/byName/app-version");
    if (response?.data?.status && response?.data?.result) {
      const raw = response.data.result;
      if (typeof raw === "string") {
        try {
          return JSON.parse(raw);
        } catch {
          return null;
        }
      }
      return raw;
    }
    return null;
  } catch (error) {
    if (error?.response?.status === 404) {
      return null;
    }
    throw error;
  }
};

export const updateAppVersionConfig = async (configData) => {
  const payload = {
    name: "app-version",
    value: typeof configData === "string" ? configData : JSON.stringify(configData),
  };
  const response = await CONFIG_INSTANCES.post("config/create", payload);
  return response.data;
};
